import { useState } from "react";
import "../index.css";
import { ReactComponent as RmLogo } from "../images/rmlogo.svg";
import ThemeToggle from "../ThemeToggle";

const isMobileUA = () =>
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

function MobileNav() {
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  const scrollToSkills = () => {
    closeMenu();
    if (window.innerWidth > 768 && isMobileUA()) {
      window.scrollTo(0, 1600);
    } else if (window.innerWidth > 380 && isMobileUA()) {
      window.scrollTo(0, 900);
    } else if (window.innerWidth > 300 && isMobileUA()) {
      window.scrollTo(0, 1620);
    }
  };

  const scrollToResume = () => {
    closeMenu();
    if (window.innerWidth > 768 && isMobileUA()) {
      window.scrollTo(0, 2450);
    } else if (window.innerWidth > 380 && isMobileUA()) {
      window.scrollTo(0, 1850);
    } else if (window.innerWidth > 300 && isMobileUA()) {
      window.scrollTo(0, 2830);
    }
  };

  const scrollToContact = () => {
    closeMenu();
    if (window.innerWidth > 768 && isMobileUA()) {
      window.scrollTo(0, document.body.scrollHeight);
    } else if (window.innerWidth > 380 && isMobileUA()) {
      window.scrollTo(0, 3450);
    } else if (window.innerWidth > 300 && isMobileUA()) {
      window.scrollTo(0, 3650);
    }
  };

  return (
    <>
      <div
        name="container-for-hamburger"
        className="flex fixed justify-start items-center mix-blend-difference z-40 w-full h-[4rem] visible pointer-events-none sm:invisible"
      >
        <div className="z-50 pointer-events-auto" id="fixed-menu">
          <svg
            className={`ham ham6${open ? " active" : ""}`}
            viewBox="0 0 100 100"
            width="80"
            id="hamburger"
            onClick={() => setOpen((prev) => !prev)}
          >
            <path
              className="line top"
              d="m 30,33 h 40 c 13.100415,0 14.380204,31.80258 6.899646,33.421777 -24.612039,5.327373 9.016154,-52.337577 -12.75751,-30.563913 l -28.284272,28.284272"
            />
            <path
              className="line middle"
              d="m 70,50 c 0,0 -32.213436,0 -40,0 -7.786564,0 -6.428571,-4.640244 -6.428571,-8.571429 0,-5.895471 6.073743,-11.783399 12.286435,-5.570707 6.212692,6.212692 28.284272,28.284272 28.284272,28.284272"
            />
            <path
              className="line bottom"
              d="m 69.575405,67.073826 h -40 c -13.100415,0 -14.380204,-31.80258 -6.899646,-33.421777 24.612039,-5.327373 -9.016154,52.337577 12.75751,30.563913 l 28.284272,-28.284272"
            />
          </svg>
        </div>
      </div>
      <div className="flex justify-center items-center fixed z-10 w-full h-[4rem] bg-bg/80 backdrop-filter backdrop-blur-sm border-b border-border visible sm:invisible ">
        <div className="flex items-center px-3 py-1">
          <RmLogo role="img" aria-label="RM logo" className="h-8 w-8" />
        </div>
        <ThemeToggle className="absolute right-3 top-1/2 -translate-y-1/2" />
      </div>
      <div
        className={`mobilenav--wrap font-semibold text-eyebrow bg-bg${
          open ? " show--mobilenav" : ""
        }`}
      >
        <div className="mobilenav bg-bg">
          <ul>
            <li className="ml-6">
              <button className="text-text noSelect" onClick={scrollToSkills}>
                Skills
              </button>
            </li>
            <li className="ml-6">
              <button className="text-text noSelect" onClick={scrollToResume}>
                Resume
              </button>
            </li>
            <li className="ml-6">
              <button className="text-text noSelect" onClick={scrollToContact}>
                Contact
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
export default MobileNav;
